<template>
  <b-card v-bind:border-variant="borderVariant">
    <b-card-title title-tag="h6" :class="{ 'mb-1': true }">
      <strong>
        {{ configuration.Characteristics[value.Characteristic].CharacteristicText }}
        <template v-if="configuration.Characteristics[value.Characteristic].Required"><span title="Required" alt="Required">(*)</span></template>
      </strong>
    </b-card-title>
    <b-card-text>
      <template v-if="configuration.Characteristics[value.Characteristic].Values && configuration.Characteristics[value.Characteristic].Values.length > 0">
        <template v-if="configuration.Characteristics[value.Characteristic].Disabled">
          <p class="m-1" v-for="val in getValue(value.Values, configuration.Characteristics[value.Characteristic].Values)" :key="val.Value">{{ val.ValueText }}</p>
        </template>
        <template v-else>
          <template v-if="!(configuration.Characteristics[value.Characteristic].Values.length === 1 && configuration.Characteristics[value.Characteristic].Values[0].ValueUsage !== '1')">
            <multiselect-listbox
              :value="getValue(value.Values, configuration.Characteristics[value.Characteristic].Values)"
              :disabled="configuration.Characteristics[value.Characteristic].Disabled"
              :multiple="!configuration.Characteristics[value.Characteristic].SingleValue"
              :checkmark="!configuration.Characteristics[value.Characteristic].SingleValue"
              :options="configuration.Characteristics[value.Characteristic].Values"
              filterPlaceholder="Select an option"
              optionValue="Value"
              optionLabel="ValueText"
              @input="val => valueChange(val)"
            >
            </multiselect-listbox>
          </template>
          <template v-else>
            <b-form-input
              v-model="value.Values[0]"
              :placeholder="configuration.Characteristics[value.Characteristic].Values[0].ValueText"
              :maxlength="configuration.Characteristics[value.Characteristic].DataLength"
              @change="valueChange(value.Values)"
            ></b-form-input>
          </template>
        </template>
      </template>
      <template v-else>
        <b-input-group >
          <b-form-input
            v-model="value.Values[0]" v-bind:disabled="configuration.Characteristics[value.Characteristic].Disabled"
            :maxlength="configuration.Characteristics[value.Characteristic].DataLength"
            @change="valueChange(value.Values)"
          ></b-form-input>
        </b-input-group>
      </template>
    </b-card-text>
  </b-card>
</template>

<script lang="ts">
import MxSite from '@/mixins/site'
import MultiselectListbox from './multiselect.vue'
import { Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const nsConfigurableMaterial = namespace('configurable-material')

@Component({
  name: 'configurable-material-value',
  components: {
    MultiselectListbox,
  },
})
export default class extends MxSite {
  @Prop()
  public value: any

  @nsConfigurableMaterial.Action('setValue')
  private setValue: any

  @nsConfigurableMaterial.Getter('configuration')
  public configuration: any

  public hehe: any = []

  public getValue(values: string[], options: any[]) {
    return options.filter(s => values.indexOf(s.Value) >= 0)
  }

  public valueChange(value: any) {
    console.log('change', value)
    this.value.Values = []
    if (value) {
      let values = [value]
      if (Array.isArray(value)) {
        values = [...value]
      }
      for (let index = 0; index < values.length; index++) {
        this.value.Values.push((typeof values[index] === 'object' ? values[index].Value : values[index]))
      }
    }
    this.setOverlayShowing(true)
    this.setValue(this.value).then(() => {
      this.setOverlayShowing(false)
    })
  }

  public get needsValue(): boolean {
    return this.configuration.Characteristics[this.value.Characteristic].Required && this.value.Values.length === 0
  }

  public get hasValue(): boolean {
    return this.configuration.Characteristics[this.value.Characteristic].Required && this.value.Values.length > 0
  }

  public get isRequired(): boolean {
    return this.configuration.IncompleteCharacteristics.indexOf(this.value.Characteristic) >= 0
  }

  public get borderVariant(): string {
    return this.isRequired ? 'warning' : 'none'
  }
}
</script>
<style>
.nested-section {
    border-left: 4px solid #007bff;
    padding-left: 1.5rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
    transition: border-color 0.3s;
}
.card-columns {
  @media (min-width: 576px) {
    column-count: 1 !important;
  }
  @media (min-width: 768px) {
    column-count: 1 !important;
  }
  @media (min-width: 992px) {
    column-count: 2 !important;
  }
  @media (min-width: 1200px) {
    column-count: 3 !important;
  }
}
</style>
